(function() {
  var slideout = document.getElementById('product-info-slideout');
  var overlay  = document.getElementById('pis-overlay');
  if (!slideout || !overlay) return;

  var tabs   = slideout.querySelectorAll('[data-pis-tab]');
  var panels = slideout.querySelectorAll('[data-pis-panel]');
  var lastFocusedBeforeOpen = null;

  function open(tabName) {
    slideout.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    slideout.removeAttribute('aria-hidden');
    slideout.removeAttribute('inert');
    if (tabName) switchTab(tabName);
    var focusTarget = slideout.querySelector('[data-pis-close]');
    if (focusTarget) focusTarget.focus();
  }

  function close() {
    slideout.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    slideout.setAttribute('aria-hidden', 'true');
    slideout.setAttribute('inert', '');
    if (lastFocusedBeforeOpen) { lastFocusedBeforeOpen.focus(); lastFocusedBeforeOpen = null; }
    if (lotInput && lotInput.value) { lotInput.value = ''; filterLots(''); }
  }

  function switchTab(name) {
    for (var i = 0; i < tabs.length; i++) {
      var isTarget = tabs[i].getAttribute('data-pis-tab') === name;
      if (isTarget) { tabs[i].classList.add('is-active'); } else { tabs[i].classList.remove('is-active'); }
      tabs[i].setAttribute('aria-selected', isTarget ? 'true' : 'false');
    }
    for (var j = 0; j < panels.length; j++) {
      if (panels[j].getAttribute('data-pis-panel') === name) {
        panels[j].classList.add('is-active');
      } else {
        panels[j].classList.remove('is-active');
      }
    }
  }

  function variantHasCoa(id) {
    return !!slideout.querySelector('[data-pis-variant-coa="' + id + '"]');
  }

  function updateTestingVisibility(id) {
    var hasCoa = variantHasCoa(id);

    // Show/hide the Testing tab
    var testingTab = slideout.querySelector('[data-pis-tab="testing"]');
    if (testingTab) testingTab.style.display = hasCoa ? '' : 'none';

    // If the testing panel is active but this variant has no COA, drop back to ingredients
    if (!hasCoa) {
      var testingPanel = slideout.querySelector('[data-pis-panel="testing"]');
      if (testingPanel && testingPanel.classList.contains('is-active')) {
        switchTab('ingredients');
      }
    }

    // Show/hide every testing trigger on the page (tab trigger link, trust bar button, etc.)
    var triggers = document.querySelectorAll('[data-open-pis="testing"]');
    for (var t = 0; t < triggers.length; t++) {
      triggers[t].style.display = hasCoa ? '' : 'none';
    }
    // Show/hide whole testing UI blocks (e.g. the trust bar container)
    var blocks = document.querySelectorAll('[data-pis-testing-block]');
    for (var b = 0; b < blocks.length; b++) {
      blocks[b].style.display = hasCoa ? '' : 'none';
    }
  }

  function switchVariant(variantId) {
    var id = String(variantId);

    // Switch ingredients
    var ingredientPanels = slideout.querySelectorAll('[data-pis-variant-ingredients]');
    for (var a = 0; a < ingredientPanels.length; a++) {
      ingredientPanels[a].style.display = ingredientPanels[a].getAttribute('data-pis-variant-ingredients') === id ? '' : 'none';
    }

    // Switch supplement facts
    var sfPanels = slideout.querySelectorAll('[data-pis-variant-sf]');
    for (var b = 0; b < sfPanels.length; b++) {
      sfPanels[b].style.display = sfPanels[b].getAttribute('data-pis-variant-sf') === id ? '' : 'none';
    }

    // Switch COA folders
    var coaPanels = slideout.querySelectorAll('[data-pis-variant-coa]');
    for (var c = 0; c < coaPanels.length; c++) {
      coaPanels[c].style.display = coaPanels[c].getAttribute('data-pis-variant-coa') === id ? '' : 'none';
    }

    // Switch certifications
    var certPanels = slideout.querySelectorAll('[data-pis-variant-certs]');
    for (var d = 0; d < certPanels.length; d++) {
      certPanels[d].style.display = certPanels[d].getAttribute('data-pis-variant-certs') === id ? '' : 'none';
    }

    // Show/hide testing tab and trigger links based on whether this variant has COA docs
    updateTestingVisibility(id);
  }

  function testingTabAvailable() {
    var testingTab = slideout.querySelector('[data-pis-tab="testing"]');
    return !!testingTab && testingTab.style.display !== 'none';
  }

  // Trigger links anywhere on the page.
  // Rich text editors cannot add data attributes, so links with
  // href="#pis-ingredients" or href="#pis-testing" open the slideout too.
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-open-pis], a[href="#pis-ingredients"], a[href="#pis-testing"]');
    if (trigger) {
      e.preventDefault();
      lastFocusedBeforeOpen = document.activeElement;
      var panel = trigger.getAttribute('data-open-pis');
      if (!panel) panel = trigger.getAttribute('href').replace('#pis-', '');
      if (panel === 'testing' && !testingTabAvailable()) panel = 'ingredients';
      open(panel);
    }
  });

  // Tab clicks and keyboard navigation (ARIA tablist pattern)
  var tabList = slideout.querySelector('[role="tablist"]');
  if (tabList) {
    tabList.addEventListener('click', function(e) {
      var tab = e.target.closest('[data-pis-tab]');
      if (tab) switchTab(tab.getAttribute('data-pis-tab'));
    });
    tabList.addEventListener('keydown', function(e) {
      var tabArr = Array.prototype.slice.call(tabs);
      var current = tabArr.indexOf(document.activeElement);
      if (current === -1) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        var next = e.key === 'ArrowRight' ? (current + 1) % tabArr.length : (current - 1 + tabArr.length) % tabArr.length;
        tabArr[next].focus();
        switchTab(tabArr[next].getAttribute('data-pis-tab'));
      } else if (e.key === 'Home') {
        e.preventDefault();
        tabArr[0].focus();
        switchTab(tabArr[0].getAttribute('data-pis-tab'));
      } else if (e.key === 'End') {
        e.preventDefault();
        tabArr[tabArr.length - 1].focus();
        switchTab(tabArr[tabArr.length - 1].getAttribute('data-pis-tab'));
      }
    });
  }

  // Close + focus trap
  var closeBtn = slideout.querySelector('[data-pis-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function(e) {
    if (!slideout.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var focusable = Array.prototype.slice.call(
        slideout.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function(el) { return !el.hidden && el.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  });

  // Show more buttons for long document lists
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-pis-show-more]');
    if (!btn) return;
    var folder = btn.closest('.pis-folder');
    if (!folder) return;
    var hidden = folder.querySelectorAll('.pis-doc-item.is-hidden');
    for (var h = 0; h < hidden.length; h++) {
      hidden[h].classList.remove('is-hidden');
    }
    btn.hidden = true;
  });

  // Lot number search
  var lotInput    = slideout.querySelector('.pis-lot-search__input');
  var lotClear    = slideout.querySelector('[data-pis-lot-clear]');
  var noResults   = slideout.querySelector('[data-pis-no-results]');
  var noResultsTerm = noResults && noResults.querySelector('.pis-no-results__term');

  function getVisibleCoaContainer() {
    var containers = slideout.querySelectorAll('[data-pis-variant-coa]');
    for (var i = 0; i < containers.length; i++) {
      if (containers[i].style.display !== 'none') return containers[i];
    }
    return null;
  }

  function filterLots(term) {
    var container = getVisibleCoaContainer();
    if (!container) return;
    var docs = container.querySelectorAll('.pis-doc-item');
    var matched = 0;
    for (var i = 0; i < docs.length; i++) {
      var lot = (docs[i].getAttribute('data-lot') || '').toLowerCase();
      var show = term === '' || lot.indexOf(term) !== -1;
      docs[i].style.display = show ? '' : 'none';
      // When searching, override is-hidden so all matches are visible
      if (show) { docs[i].classList.remove('is-hidden'); matched++; }
    }
    // Show/hide "show more" buttons — hide them during search
    var showMoreBtns = container.querySelectorAll('[data-pis-show-more]');
    for (var j = 0; j < showMoreBtns.length; j++) {
      showMoreBtns[j].style.display = term === '' ? '' : 'none';
    }
    // Hide folder entirely if it has no visible docs
    var folders = container.querySelectorAll('.pis-folder');
    for (var f = 0; f < folders.length; f++) {
      var folderDocs = folders[f].querySelectorAll('.pis-doc-item');
      var anyVisible = false;
      for (var fd = 0; fd < folderDocs.length; fd++) {
        if (folderDocs[fd].style.display !== 'none') { anyVisible = true; break; }
      }
      folders[f].style.display = anyVisible ? '' : 'none';
    }
    // Restore is-hidden when cleared — reset per folder so each folder's limit is independent.
    // If the user had already clicked "Show all" (btn.hidden === true), preserve the expanded state.
    if (term === '') {
      var folders = container.querySelectorAll('.pis-folder');
      for (var f = 0; f < folders.length; f++) {
        folders[f].style.display = '';
        var showMoreBtn = folders[f].querySelector('[data-pis-show-more]');
        var isExpanded = showMoreBtn && showMoreBtn.hidden;
        if (showMoreBtn) showMoreBtn.style.display = '';
        var folderDocs = folders[f].querySelectorAll('.pis-doc-item');
        var count = 0;
        for (var k = 0; k < folderDocs.length; k++) {
          folderDocs[k].style.display = '';
          count++;
          if (!isExpanded && count > 3) folderDocs[k].classList.add('is-hidden');
          else folderDocs[k].classList.remove('is-hidden');
        }
      }
    }
    // No-results state
    if (noResults) {
      var show_no = term !== '' && matched === 0;
      noResults.hidden = !show_no;
      if (noResultsTerm) noResultsTerm.textContent = term;
    }
    if (lotClear) lotClear.hidden = term === '';
  }

  if (lotInput) {
    lotInput.addEventListener('input', function() {
      filterLots(this.value.trim().toLowerCase());
    });
  }
  if (lotClear) {
    lotClear.addEventListener('click', function() {
      if (lotInput) { lotInput.value = ''; lotInput.focus(); }
      filterLots('');
    });
  }

  // Sync testing visibility on page load for the initially selected variant
  (function initTestingVisibility() {
    var params = new URLSearchParams(window.location.search);
    var initialId = params.get('variant');
    if (!initialId) {
      // Find the COA panel that Liquid rendered without display:none
      var coaPanels = slideout.querySelectorAll('[data-pis-variant-coa]');
      for (var i = 0; i < coaPanels.length; i++) {
        if (coaPanels[i].style.display !== 'none') {
          initialId = coaPanels[i].getAttribute('data-pis-variant-coa');
          break;
        }
      }
    }
    updateTestingVisibility(initialId || '');
  })();

  // Listen for variant changes.
  // product-form-variant-selects.js dispatches a plain Event (no detail) and
  // sets window.globalVariables.product.currentVariant before firing it.
  document.addEventListener('variant:changed', function() {
    var variant = window.globalVariables
      && window.globalVariables.product
      && window.globalVariables.product.currentVariant;
    if (variant && variant.id) {
      switchVariant(variant.id);
    }
  });

  // Fallback: plain select with name="id" (non-swatch themes)
  document.addEventListener('change', function(e) {
    var select = e.target.closest('[name="id"]');
    if (select) {
      switchVariant(select.value);
    }
  });

  // Listen for variant change via URL (back/forward navigation)
  window.addEventListener('popstate', function() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (lotInput && lotInput.value) { lotInput.value = ''; filterLots(''); }
    if (variantId) {
      switchVariant(variantId);
    } else {
      var coaPanels = slideout.querySelectorAll('[data-pis-variant-coa]');
      for (var i = 0; i < coaPanels.length; i++) {
        if (coaPanels[i].style.display !== 'none') {
          updateTestingVisibility(coaPanels[i].getAttribute('data-pis-variant-coa'));
          break;
        }
      }
    }
  });

  // Release body scroll lock if the page is put into bfcache (browser back nav while open)
  window.addEventListener('pagehide', close);
})();



